import React from 'react';
import { Result, Button } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { logout } from '@efsa/dlw-authenticator';

const StyledResult = styled(Result)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export interface IErrorPageProps {
  error: any;
}

const ErrorPage = ({ error }: IErrorPageProps) => {
  return (
    <StyledResult
      status="500"
      title="An error occurred"
      subTitle={
        <div>
          <p>{error?.data?.Error?.Message}</p>
          <Button
            size="large"
            type="primary"
            onClick={() => {
              logout();
            }}
          >
            Logout
          </Button>
        </div>
      }
    />
  );
};

ErrorPage.propTypes = {
  error: PropTypes.object.isRequired,
};

export default ErrorPage;
